import { nanoid } from "nanoid";

export function uniqueId ( prefix: string = "_APID_", length: number = 12 ): string {
  return prefix + nanoid( length );
}
